import { ReactNode } from "react";
import styles from "./CloseButtonWrapper.module.css";

type CloseButtonWrapperProps = {
  children: ReactNode;
};

function CloseButtonWrapper({ children }: CloseButtonWrapperProps) {
  return <div className={styles["root"]}>{children}</div>;
}

export default CloseButtonWrapper;
